/*
 *
 * Login actions
 *
 */

import {
  LOGIN_WATCHER,
  LOGIN_FAILED,
  LOGIN_SUCCESS,
  LOGIN_EXCEED,
  LOGIN_RESET,
  LOGIN_COMPANY_WATCHER,
  LOGIN_PROOF_INTEGRATED,
  TWO_FACTOR_AUTH_RESEND_WATCHER,
} from "./constants"

export function loginWatcher(authParams) {
  return {
    type: LOGIN_WATCHER,
    payload: authParams,
  }
}

export function loginFailed() {
  return { type: LOGIN_FAILED }
}

export function loginSuccess(token) {
  return {
    type: LOGIN_SUCCESS,
    payload: token,
  }
}

export function loginExceed(error) {
  return {
    type: LOGIN_EXCEED,
    payload: error,
  }
}

export function loginReset() {
  return { type: LOGIN_RESET }
}

export function loginProofIntegrated(authParams) {
  return { type: LOGIN_PROOF_INTEGRATED, payload: authParams }
}

export function loginCompanyWatcher(authParams) {
  return {
    type: LOGIN_COMPANY_WATCHER,
    payload: authParams,
  }
}

export function resendTwoFactorCodeWatcher(params) {
  return {
    type: TWO_FACTOR_AUTH_RESEND_WATCHER,
    payload: params,
  }
}
